import { BackButtonBar } from "app/components/back-button/back-button.component";
import { useNavigateBack } from "app/hooks/navigation.hook";
import axios from "axios";
import { useQuery } from "react-query";
import styles from "./terms-of-use.module.scss";

export const TermsOfUse: React.FC = () => {
  const goBack = useNavigateBack();
  const response = useQuery("terms-of-use", () =>
    axios.get("/media/docs/Term-of-use.html")
  );
  const body = response.data?.data
    ? /<body.*?>([\s\S]*)<\/body>/.exec(response.data?.data)
    : null;
  return (
    <div>
      <BackButtonBar onClick={goBack} />
      <div className={styles.iframe_wrapper}>
        {body && (
          <div
            className={styles.wrapper}
            dangerouslySetInnerHTML={{ __html: body[1] }}
          ></div>
        )}
      </div>
    </div>
  );
};
export default TermsOfUse;
